import { render } from "./SearchTemporarySales.vue?vue&type=template&id=7a521b60"
import script from "./SearchTemporarySales.vue?vue&type=script&lang=js"
export * from "./SearchTemporarySales.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__